import type { I18n, LangCode } from '@learnforge/i18n';

export interface LangPickerHandle {
  destroy(): void;
}

export function mountLangPicker(el: HTMLElement, i18n: I18n<string>): LangPickerHandle {
  el.classList.add('lang-picker');
  el.innerHTML = `<select aria-label="Language"></select>`;
  const select = el.querySelector('select') as HTMLSelectElement;

  for (const lang of i18n.languages()) {
    const opt = document.createElement('option');
    opt.value = lang.code;
    opt.textContent =
      lang.nativeName === lang.englishName
        ? lang.nativeName
        : `${lang.nativeName} · ${lang.englishName}`;
    select.appendChild(opt);
  }
  select.value = i18n.currentLang();

  const onChange = () => {
    i18n.setLang(select.value as LangCode);
  };
  select.addEventListener('change', onChange);

  const unsubscribe = i18n.subscribe((lang) => {
    if (select.value !== lang) select.value = lang;
  });

  return {
    destroy() {
      select.removeEventListener('change', onChange);
      unsubscribe();
    },
  };
}
